import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Header extends Component {
    state = { 
        headerToggle:false
     }
    render() { 
        return ( 
            <header>
                <div className="logo">
                        <Link to="/"><img src={require("./../images/logo.png")} width="100%" alt=""/></Link>
                </div>
                <nav>
                    <div className="hamburger-menu" id="hamburger" onClick={()=>this.logThis()}>
                        <i className="fas fa-bars"></i>
                    </div>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/user-info">Users</Link></li>
                        <li><Link to="/trucker-info">Trucker</Link></li>
                        <li className="register">
                            Register now
                            <div>
                                <ul>
                                    <li><Link to="/trucker-registration">Trucker Register</Link></li>
                                    <li><Link to="/not-available">Company Register</Link></li>
                                </ul>
                            </div> 
                        </li>
                    </ul>
                </nav>
                <div className="mobile" id="mobile">
                    <ul>
                        <Link to="/" onClick={()=> this.logThis()}><li>Home</li></Link>
                        <Link to="/user-info" onClick={()=> this.logThis()}><li>Users</li></Link>
                        <Link to="/trucker-info" onClick={()=> this.logThis()}><li>Trucker</li></Link>
                        <Link to="/trucker-registration" onClick={()=> this.logThis()}><li>Trucker Register</li></Link>
                        <Link to="/not-available" onClick={()=> this.logThis()}><li>Company Register</li></Link>
                    </ul>
                </div>
            </header>
         );
    }
    //Expand and collapse menu
    logThis(){
        let headerInfo = document.getElementById('mobile');
        let hamBurger = document.getElementById('hamburger');
        if(headerInfo.style.height !== ''){
            hamBurger.innerHTML = '<i class="fas fa-times"></i>';
            headerInfo.style.height = '';
            headerInfo.style.padding = '';
        }else{
            hamBurger.innerHTML = '<i class="fas fa-bars"></i>';
            headerInfo.style.height = 0;
            headerInfo.style.padding = 0;
        }
    }
    componentDidMount(){
        let headerInfo = document.getElementById('mobile');
        headerInfo.style.height = 0;
        headerInfo.style.padding = 0;
        window.addEventListener('scroll',()=>{
            headerInfo.style.height = '';
            this.logThis()
        });
    }
}
 
export default Header;